import React from 'react';
import { Text } from 'react-native';
//import { WebView } from 'react-native-webview';
//import { useRouter } from 'expo-router';
import { SafeAreaView } from 'react-native-safe-area-context';

import Header from '@/components/header';

export default function HomeScreen() {
  //const router = useRouter();

  return (
    <SafeAreaView style={{flex: 1}}>
      <Header />
      <Text>Hello Web Index (auth)!</Text>
    </SafeAreaView>
  );
}
